import { render, staticRenderFns } from "./closuresGrid.vue?vue&type=template&id=27c96b8c&scoped=true"
import script from "./closuresGrid.vue?vue&type=script&lang=js"
export * from "./closuresGrid.vue?vue&type=script&lang=js"
import style0 from "./closuresGrid.vue?vue&type=style&index=0&id=27c96b8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c96b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c96b8c')) {
      api.createRecord('27c96b8c', component.options)
    } else {
      api.reload('27c96b8c', component.options)
    }
    module.hot.accept("./closuresGrid.vue?vue&type=template&id=27c96b8c&scoped=true", function () {
      api.rerender('27c96b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/closuresGrid.vue"
export default component.exports